import React from 'react';

import Masker from '../assets/image/protocol/pakai-masker.png';
import CuciTangan from '../assets/image/protocol/cuci-tangan.png';
import JagaJarak from '../assets/image/protocol/jaga-jarak.png';
import JabatTangan from '../assets/image/protocol/jabat-tangan.png';
import Vaksinasi from '../assets/image/protocol/vaksinasi.png';
import Kerumunan from '../assets/image/protocol/kerumunan.png';
import { motion } from "framer-motion";

const Protocol = () => {
  return (
    <div className="py-24">
        <div className="text-base text-2xl px-5 text-center pb-16 font-poppins text-gray-darkest">
          Protokol Kesehatan Pencegahan COVID 19
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 text-white gap-4 mx-10">
            <motion.div
            whileHover={{ scale: 0.8, rotate: 10 }}
            whileTap={{
                scale: 0.8,
                rotate: -10,
                // borderRadius: "100%"
            }}
            >
                <div className="bg-gray-wedlist font-poppins rounded-3xl px-6 py-5 lg:px-5 lg:py-5 lg:mx-12 mx-14">
                    <di className="grid justify-items-center">
                        <img
                            className="d-block lg:w-44"
                            src={Masker}
                            alt="masker"
                        />
                        <div className="font-poppins text-center text-sm mt-2">
                            <span>
                                Memakai masker dengan benar
                            </span>
                        </div>
                    </di>
                </div>
            </motion.div>
            <motion.div
            whileHover={{ scale: 0.8, rotate: -10 }}
            whileTap={{
                scale: 0.8,
                rotate: 10,
                // borderRadius: "100%"
            }}
            >
                <div className="bg-gray-wedlist font-poppins rounded-3xl px-6 py-5 lg:px-5 lg:py-5 lg:mx-12 mx-14">
                    <di className="grid justify-items-center">
                        <img
                            className="d-block lg:w-44"
                            src={CuciTangan}
                            alt="cuci-tangan"
                        />
                        <div className="font-poppins text-center text-sm mt-2">
                            <span>
                                Mencuci tangan pakai sabun
                            </span>
                        </div>
                    </di>
                </div>
            </motion.div>
            <motion.div
            whileHover={{ scale: 0.8, rotate: 10 }}
            whileTap={{
                scale: 0.8,
                rotate: -10,
                // borderRadius: "100%"
            }}
            >
                <div className="bg-gray-wedlist font-poppins rounded-3xl px-6 py-5 lg:px-5 lg:py-5 lg:mx-12 mx-14">
                    <di className="grid justify-items-center">
                        <img
                            className="d-block lg:w-44"
                            src={JagaJarak}
                            alt="jaga-jarak"
                        />
                        <div className="font-poppins text-center text-sm mt-2">
                            <span>
                                Selalu menjaga jarak
                            </span>
                        </div>
                    </di>
                </div>
            </motion.div>
            <motion.div
            whileHover={{ scale: 0.8, rotate: -10 }}
            whileTap={{
                scale: 0.8,
                rotate: 10,
                // borderRadius: "100%"
            }}
            >
                <div className="bg-gray-wedlist font-poppins rounded-3xl px-6 py-5 lg:px-5 lg:py-5 lg:mx-12 mx-14 lg:mt-5">
                    <di className="grid justify-items-center">
                        <img
                            className="d-block lg:w-44"
                            src={JabatTangan}
                            alt="jabat-tangan"
                        />
                        <div className="font-poppins text-center text-sm mt-2">
                            <span>
                                Hindari berjabat tangan
                            </span>
                        </div>
                    </di>
                </div>
            </motion.div>
            <motion.div
            whileHover={{ scale: 0.8, rotate: 10 }}
            whileTap={{
                scale: 0.8,
                rotate: -10,
                // borderRadius: "100%"
            }}
            >
                <div className="bg-gray-wedlist font-poppins rounded-3xl px-6 py-5 lg:px-5 lg:py-5 lg:mx-12 mx-14 lg:mt-5">
                    <di className="grid justify-items-center">
                        <img
                            className="d-block lg:w-44"
                            src={Vaksinasi}
                            alt="vaksinasi"
                        />
                        <div className="font-poppins text-center text-sm mt-2">
                            <span>
                                Melakukan vaksinasi
                            </span>
                        </div>
                    </di>
                </div>
            </motion.div>
            <motion.div
            whileHover={{ scale: 0.8, rotate: -10 }}
            whileTap={{
                scale: 0.8,
                rotate: 10,
                // borderRadius: "100%"
            }}
            >
                <div className="bg-gray-wedlist font-poppins rounded-3xl px-6 py-5 lg:px-5 lg:py-5 lg:mx-12 mx-14 lg:mt-5">
                    <di className="grid justify-items-center">
                        <img
                            className="d-block lg:w-44"
                            src={Kerumunan}
                            alt="kerumunan"
                        />
                        <div className="font-poppins text-center text-sm mt-2">
                            <span>
                                Menjahui Berkerumun
                            </span>
                        </div>
                    </di>
                </div>
            </motion.div>
        </div>
    </div>
  )
}

export default Protocol;